import { RouteConfig } from "vue-router";

export const REmployerRolesBrowse: RouteConfig = {
  path: "",
  name: "EmployerRoleTemplates",
  component: () =>
    import(
      /* webpackChunkName: "employer-roles-browse" */
      "./VEmployerRolesBrowse.vue"
    ),
  meta: {
    title: "Job position templates",
  },
};
